import React from 'react'
import { useSelector } from 'react-redux';
import classes from './Tabs.module.css';

const Tabs = ({ setCurrentTab, currentTab, typeEnum }) => {

    const texts = useSelector((state) => state.translate.texts);

    return (
        <>
            <div className={classes.Tabs}>
                {Object.entries(typeEnum).map(([key, value]) =>
                    <div key={key}
                        className={`${classes.Tab} ${currentTab == value ? classes.CurrentTab : classes.Tab}`}
                        onClick={() => setCurrentTab(value)}>{texts[key]}</div>
                )}
            </div>
            <div className={classes.TabsUnderLine}></div>
        </>
    )
}

export default Tabs